<template>
  <div :id="this.$route.name">
    <card back :add="true" :edit="editgrp">
      <template v-slot:header>
        <h4 class="d-inline">لـیست سـمـت</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row" dir="rtl">
          <div class="col-md-6 col-12">
            <treeselect class="mt-2" placeholder="برای مشاهده سمت ها کلیک کنید" name="demo" :multiple="false" :options="treeSematha" :alwaysOpen="true" :noChildrenText="farsiNochild" :closeOnSelect="false" :show-count="true" v-model="value">
              <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName" @click.prevent="ItemSelected(node)">
                {{ node.label }}
                <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
              </label>
            </treeselect>
          </div>
        </div>
        <div class="row" dir="rtl"></div>
      </template>
    </card>
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Card from '@/components/Card/Card.vue'
export default {
  components: { Card, Treeselect },
  data() {
    return {
      DataAxios: {
        ArryfildValue: '',
        Method: 'Get',
        Action: this.$route.name,
        Token: this.$session.get('Token'),
      },
      TreeSematha: [],
      farsiNochild: 'فاقد زیر مجموعه',
      value: null,
      treeSematha: [],
      treeItemSelected: null,
      addgrp: false,
      editgrp: false,
      DataAxios_DataGrp: {
        ArryfildValue: '',
        Method: 'Get',
        Action: this.$route.name,
        Token: this.$session.get('Token'),
      },
      DataAxiosRow: {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'DastresiDB/GettblDB',
        Token: this.$session.get('Token'),
      },
      RowsGridGrpDb: null,
    }
  },
  beforeMount() {
    this.$GetData_Body(this.DataAxios)
      .then((data) => {
        this.TreeSematha = data
      })
      .finally(() => {
        this.$store.state.treeSemathaFlat = this.TreeSematha
        this.treeSematha = this.convert2(
          this.TreeSematha
        );
      })
  },
  mounted() {
    this.$GetData_Body(this.DataAxiosRow)
      .then((data) => {
        this.RowsGridGrpDb = data
      })
      .finally(() => {
        this.$store.state.TreeSematha = this.RowsGridGrpDb
      })
  },
  beforeUpdate() {
    try {
      if (this.$store.state.TreeSematha != null) {
        var Tree = this.$store.state.TreeSematha
        let infoTree
        var listTree = []
        for (let index = 0; index < Tree.length; index++) {
          infoTree = Tree[index]
          listTree.push(infoTree)
        }
      }
    } catch (error) {
      console.log(error + 'error')
    }
  },
  methods: {
    convert(arrayTree) {
      var map = {}
      for (var i = 0; i < arrayTree.length; i++) {
        var objTree = arrayTree[i]
        objTree.children = []

        map[objTree.id] = objTree

        var ParentId = objTree.ParentId || '-'

        if (!map[ParentId]) {
          map[ParentId] = {
            children: [],
          }
        }
        map[ParentId].children.push(objTree)
      }
      return map['-'].children
    },
    convert2(arr) {
      var flattenedArray = []
      var parentIdMap = {}

      // ایجاد نگاشتی بین parentId و شیء مربوطه
      for (var i = 0; i < arr.length; i++) {
        var item = arr[i]
        parentIdMap[item.id] = item
      }

      // تو در تو کردن آرایه بر اساس parentId
      for (var j = 0; j < arr.length; j++) {
        var currentItem = arr[j]
        var parentItem = parentIdMap[currentItem.ParentId]

        if (parentItem) {
          if (!parentItem.children) {
            parentItem.children = []
          }
          parentItem.children.push(currentItem)
        } else {
          flattenedArray.push(currentItem)
        }
      }

      return flattenedArray
    },
    ItemSelected(node) {
      this.treeItemSelected = node.id
      this.$store.state.TblGrpId = this.value
      this.$store.state.Grplabel = node.label
      this.addgrp = true
      this.editgrp = true
      this.$store.state.DataPostTblGrpDb = node
      this.DataAxios_DataGrp.ArryfildValue = { id: this.treeItemSelected }
      this.$FindData(this.DataAxios_DataGrp).then((data) => {
        this.$store.state.EditDataTblgrp = data
      })
    },
  },
}
</script>

<style scoped></style>
